import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyJobLanguage } from "../i18n";
import { useJobLang } from "../i18n/JobLangContext";
import API_URL from "../config";

// Recruitment backend base — the job (with content_language) is always served here.
const BE_API_URL = `${API_URL}/api-recruitment`;
const JOB_RE = /\/candidate\/job\/([^/?#]+)/;

// Headless: resolves the candidate page language from the current job's COUNTRY
// and publishes whether this is a Japan job (so the switcher shows only then).
// Japan-country jobs default to Japanese (honoring the saved switcher choice);
// every other job — and job-less routes — is English with no switcher.
const JobLanguageSync = () => {
    const location = useLocation();
    const { setIsJapanJob } = useJobLang();

    useEffect(() => {
        const match = location.pathname.match(JOB_RE);
        if (!match) {
            setIsJapanJob(false); // no job in the URL -> English, no switcher
            applyJobLanguage(false);
            return;
        }

        const jobId = match[1];
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${BE_API_URL}/jobs/${jobId}`);
                if (!res.ok) return; // keep current/default language
                const data = await res.json();
                const isJapanJob = data?.data?.country === "Japan";
                if (cancelled) return;
                setIsJapanJob(isJapanJob);
                applyJobLanguage(isJapanJob);
            } catch (_e) {
                /* network error — keep the default language */
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [location.pathname, setIsJapanJob]);

    return null;
};

export default JobLanguageSync;
